module.exports = {
    grass_field: require('./worldGenerations/grass_field'),
    diamond_square: require('diamond-square'),
    empty: require('./worldGenerations/empty'),
    superflat: require('./worldGenerations/superflat'),
    all_the_blocks: require('./worldGenerations/all_the_blocks'),
    nether: require('./worldGenerations/nether')
};
